import { Candidate } from '../models/job';
import { CandidateStatus } from '../models/types';

export type CandidateStatusCounts = Record<CandidateStatus, number>;

export function getCandidateStatusCounts(candidates: Candidate[]): CandidateStatusCounts {
  const counts: CandidateStatusCounts = {
    [CandidateStatus.PENDING]: 0,
    [CandidateStatus.SHORTLISTED]: 0,
    [CandidateStatus.INTERVIEWING]: 0,
    [CandidateStatus.INTERVIEWED]: 0,
    [CandidateStatus.ACCEPTED]: 0,
    [CandidateStatus.REJECTED]: 0,
    [CandidateStatus.HIRED]: 0,
  };

  if (!Array.isArray(candidates) || candidates.length === 0) {
    return counts;
  }

  for (let i = 0; i < candidates.length; i++) {
    const candidate = candidates[i];
    const semantic = candidate?.pipelineStageSemantic as
      | CandidateStatus
      | undefined;

    if (semantic && counts[semantic] !== undefined) {
      counts[semantic] = counts[semantic] + 1;
    }
  }

  return counts;
}

